import * as packageJson from 'packageJson';

// Build version from CI ($CI_COMMIT_TAG); package.json is the dev fallback.
// The typeof guard covers the test environment, where the define is absent.
function getVersion() {
    const buildVersion = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '';
    return normalizeVersion(buildVersion || packageJson.version);
}

// Strip the leading "v" (git-tag convention) for plain semver comparison.
function normalizeVersion(version: string): string {
    return version.replace(/^v/, '');
}

export { getVersion, normalizeVersion };
